import React from "react";
import {
  List,
  Datagrid,
  TextField,
  DateField,
  ReferenceField,
  NumberField,
  downloadCSV,
  ReferenceArrayField,
  SingleFieldList,
  ChipField,
} from "react-admin";
import jsonExport from "jsonexport/dist";

import GlobalPagination from "../common/GlobalPagination";
import { ServiceBooking } from "../types";
import serviceBookingFilters from "./serviceBookingFilters";

const exporter = (serviceBookings: ServiceBooking[]) => {
  const serviceBookingsForExport = serviceBookings.map((serviceBooking) => {
    const { serviceTemplate, customer, ...serviceBookingForExport } =
      serviceBooking;
    serviceBookingForExport.serviceTemplateName =
      serviceBooking.serviceTemplate.name;
    serviceBookingForExport.customerName = serviceBooking.customer.name;
    serviceBookingForExport.customerCrmId = serviceBooking.customer.crmId;
    serviceBookingForExport.monthlyCost =
      serviceBooking.serviceTemplate.monthlyCost;
    delete serviceBookingForExport["customer.id"];
    delete serviceBookingForExport["serviceTemplate.id"];
    return serviceBookingForExport;
  });
  jsonExport(
    serviceBookingsForExport,
    {
      // order fields in the export
      headers: [
        "id",
        "amount",
        "serviceTemplateName",
        "comment",
        "monthlyCost",
        "bookedFrom",
        "invoicedUntil",
        "canceledOn",
        "invoiceInterval",
        "billingMethod",
        "customerName",
        "customerCrmId",
        "createdAt",
        "updatedAt",
      ],
    },
    (err, csv) => {
      downloadCSV(csv, "service-bookings");
    }
  );
};

const ServiceBookingList = () => (
  <List
    sort={{ field: "bookedFrom", order: "DESC" }}
    filters={serviceBookingFilters}
    perPage={GlobalPagination.perPage}
    pagination={GlobalPagination.pagination}
    exporter={exporter}
  >
    <Datagrid rowClick="edit">
      <NumberField source="amount" label="Anzahl" textAlign="center" />
      <ReferenceField
        source="serviceTemplateId"
        reference="ServiceTemplate"
        sortable={false}
        link={false}
      >
        <TextField source="name" />
      </ReferenceField>
      <TextField source="comment" sortable={false} />

      <NumberField
        source="serviceTemplate.monthlyCost"
        label="mtl. Preis"
        options={{ style: "currency", currency: "EUR" }}
      />

      <DateField source="bookedFrom" />
      <DateField source="invoicedUntil" />
      <DateField source="canceledOn" />

      <ReferenceField
        source="customerId"
        reference="Customer"
        sortable={false}
        link="show"
      >
        <TextField source="name" />
      </ReferenceField>

      <ReferenceArrayField
        source="domainIds"
        reference="Domain"
        sortable={false}
      >
        <SingleFieldList>
          <ChipField source="unicodeName" />
        </SingleFieldList>
      </ReferenceArrayField>
    </Datagrid>
  </List>
);
export default ServiceBookingList;
